import { cn } from '@/lib/utils'

type Props = {
  src: string | null
  name: string
  size?: number
  className?: string
}

export function AuthorAvatar({ src, name, size = 32, className }: Props) {
  const initial = name?.trim()?.[0]?.toUpperCase() ?? '?'

  return (
    <div
      className={cn(
        'bg-muted flex shrink-0 items-center justify-center overflow-hidden rounded-full border text-xs font-medium',
        className
      )}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img
          src={src}
          alt={name}
          className='h-full w-full object-cover'
          loading='lazy'
        />
      ) : (
        <span className='text-muted-foreground'>{initial}</span>
      )}
    </div>
  )
}
